export const projectCard4B = {
    tabs: {
        drawing: '1',
        payment: '项目款项',
    },
    disband: '解散项目',
    exit: '退出项目',
    toBPaid: '待支付',
    rePaid: '重新下单',
    expired: '已过期',
    processing: '施工中',
    delay: '延期',
    renew: '续费',
    toBeAccepted: '待验收',
    complete: '已竣工',
    notStarted: '未开始',
    failed: '验收不通过',
    notPublish: '未发布',
    timeLine: '工期 :',
    progress: '整体进度',
    day: '天',
    dayNum: '延期天数',
    countDown: '施工倒计时',
    expireTime: '到期时间 :',
};
